import styled from 'styled-components'

export const ThresholdSettingsInputsStyled = styled.div`
    padding: 16px;
    .thresholds-header {
        display: grid;
        grid-template-areas: 'MIN MAX EQU STT CLR';
        grid-template-columns: 120px 120px 15px 120px 32px;
        gap: 16px;
        font-size: 13px;
        line-height: 16px;
        font-family: var(--font-semibold);
        margin-bottom: 4px;

        &.editing {
            grid-template-areas: 'SWT MIN MAX EQU STT CLR';
            grid-template-columns: 32px 120px 120px 15px 120px 32px;
        }

        .header-min {
            grid-area: MIN;
        }
        .header-max {
            grid-area: MAX;
        }
        .header-equals {
            grid-area: EQU;
        }
        .header-status {
            grid-area: STT;
        }
        .header-color {
            grid-area: CLR;
        }
    }
    .status-thresholds-content {
        display: flex;
        flex-direction: column;
        gap: 18px;
        .status-thresholds-bundle {
            display: grid;
            grid-template-areas: 'MIN MAX EQU STT CLR';
            grid-template-columns: 120px 120px 15px 120px 32px;
            gap: 16px;

            &.editing {
                grid-template-areas: 'SWT MIN MAX EQU STT CLR';
                grid-template-columns: 32px 120px 120px 15px 120px 32px;
            }
            > input {
                margin-left: 0;
                border: 1px solid var(--gray-300);
                border-radius: 3px 3px 0px 0px;
                font-family: var(--font-regular);
                font-size: 13px;
                line-height: 16px;
                padding: 8px;
            }
            .bundle-switch {
                margin: 0;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .bundle-min {
                grid-area: MIN;
                background: var(--gray-200);
                color: var(--gray-800);
            }
            .bundle-max {
                grid-area: MAX;
                &.last {
                    background: var(--gray-200);
                }
                &.last-relative {
                    display: none;
                }

                &.red-border {
                    border-color: var(--red-700);
                }
            }
            .bundle-equals {
                display: flex;
                align-items: center;
                justify-content: center;
                grid-area: EQU;
                font-size: 12px;
                line-height: 16px;
                height: 32px;
            }
            .bundle-status {
                display: flex;
                align-items: center;
                background: var(--gray-200);
                color: var(--gray-800);
                grid-area: STT;
            }
            .bundle-color {
                height: 32px;
                width: 32px;
                grid-area: CLR;
            }
        }
    }
`
